import React, {useContext, useMemo} from 'react';
import {Link, List, ListItem, Typography} from "@mui/material";
import {OrgCustomizationContext} from "../../OrgCustomizationProvider";
import {Trans} from "react-i18next";

const ThirdPartyProductError = () => {
    const {t, tns, language} = useContext(OrgCustomizationContext);
    const href = useMemo(() => {
        switch (language) {
            case 'en':
                return 'imdi_complaint_en.pdf'
            default:
                return 'imdi_complaint_en.pdf'
        }
    }, [language])

    return (
        <>
            <Typography variant='body1'>
                <Trans i18nKey={tns('third_party_exception_p1')}>
                    -
                    <Link href={href} sx={{color: 'primary.main'}}>
                        -
                    </Link>
                    -
                </Trans>
            </Typography>
        </>
    )
}

export default ThirdPartyProductError
